import { GanCubeCommand, GanCubeConnection, GanCubeEvent, now } from "gan-web-bluetooth";
import { Observable, Subject } from 'rxjs';
import {mathlib} from "../../hardware/mathlib";
import { BluetoothDeviceWithMAC } from "./qiyiUtils";


export class QiYiCubeConnection implements GanCubeConnection {

    device: BluetoothDeviceWithMAC;
    stateCharacteristic: BluetoothRemoteGATTCharacteristic;

    decoder: any;
    
    events$: Subject<GanCubeEvent>;

    private curCubie: mathlib.CubieCube = new mathlib.CubieCube();
    private prevCubie: mathlib.CubieCube = new mathlib.CubieCube();
    private prevMoves:string[] = [];
    private lastTs: number = 0;
    private batteryLevel: number = 0;
    private facelets: string = "";

    private constructor(
        device: BluetoothDeviceWithMAC,
        stateCharacteristic: BluetoothRemoteGATTCharacteristic,
        decoder: any,
    ) {
        this.device = device;
        this.stateCharacteristic = stateCharacteristic;
        this.decoder = decoder;
        this.events$ = new Subject<GanCubeEvent>();

        this.sendCommandMessage = this.sendCommandMessage.bind(this);
        this.onStateUpdate = this.onStateUpdate.bind(this);
        this.sendHello = this.sendHello.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.parseCubeData = this.parseCubeData.bind(this);
        this.parseFacelet = this.parseFacelet.bind(this);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.disconnect = this.disconnect.bind(this);
        
    }

    public static async create(
        device: BluetoothDeviceWithMAC,
        stateCharacteristic: BluetoothRemoteGATTCharacteristic,
        encrypter: any
    ): Promise<QiYiCubeConnection> {
        var conn = new QiYiCubeConnection(device, stateCharacteristic, encrypter);
        conn.device.addEventListener('gattserverdisconnected', conn.onDisconnect);
        conn.stateCharacteristic.addEventListener('characteristicvaluechanged', conn.onStateUpdate);
        try {
            await conn.stateCharacteristic.startNotifications();
        } catch (error) {
            console.error("Failed to start notifications", error);
        }
        try {
            await conn.sendHello(conn.device.mac || "00:00:00:00:00:00");
        } catch (error) {
            console.error("Failed to send Hello", error);
        }
       
        return conn;
    }

    get getCurrentFacelets(): string {
        return this.facelets;
    }

    get deviceName(): string {
        return this.device.name || "QY-QYSC-XXXX";
    }

    get deviceMAC(): string {
        return this.device.mac || "00:00:00:00:00:00";
    }

    async sendCommandMessage(message: Uint8Array): Promise<void> {
        var encryptedMessage = this.decoder.encrypt(message);
        return this.stateCharacteristic.writeValue(encryptedMessage);
    }

    onStateUpdate = (evt: Event) => {
        var characteristic = evt.target as BluetoothRemoteGATTCharacteristic;
        var eventMessage = characteristic.value;
        var encMsg = [];
        for (var i = 0; i < eventMessage!.byteLength; i++) {
            encMsg[i] = eventMessage!.getUint8(i);
        }
        //console.log('[qiyicube] receive enc data', encMsg);
        
        var msg = [];
        for (var i = 0; i < encMsg.length; i += 16) {
            var block = encMsg.slice(i, i + 16);
            this.decoder.decrypt(block);
            for (var j = 0; j < 16; j++) {
                msg[i + j] = block[j];
            }
        }
        //console.log('[qiyicube] decrypted msg', msg);
        msg = msg.slice(0, msg[1]);
        if (msg.length < 3 || crc16modbus(msg) != 0) {
            console.log('[qiyicube] crc checked error');
            return;
        }
        this.parseCubeData(msg);
    }

    sendHello(mac: string) {
		if (!mac) {
			return Promise.reject('empty mac');
		}
		var content = [0x00, 0x6b, 0x01, 0x00, 0x00, 0x22, 0x06, 0x00, 0x02, 0x08, 0x00];
		for (var i = 5; i >= 0; i--) {
			content.push(parseInt(mac.slice(i * 3, i * 3 + 2), 16));
		}
		return this.sendMessage(content);
	}
    
    parseFacelet(faceMsg: string | any[]) : string {
		var ret : string[] = [];
		for (var i = 0; i < 54; i++) {
			ret.push("LRDUFB".charAt(faceMsg[i >> 1] >> (i % 2 << 2) & 0xf));
		}
        this.facelets = ret.join("");
		return this.facelets;
	}
    
    parseCubeData(msg: string | any[]) {
            var locTime = Date.now();
            if (msg[0] != 0xfe) {
                console.log('[qiyicube] error cube data', msg);
            }
            var opcode = msg[2];
            var ts = (msg[3] << 24 | msg[4] << 16 | msg[5] << 8 | msg[6]);
            if (opcode == 0x2) { // cube hello
                this.batteryLevel = msg[35];
                this.sendMessage(msg.slice(2, 7));
                var newFacelet = this.parseFacelet(msg.slice(7, 34));
                //BluetoothCubeHelper.callback(newFacelet, [], [Math.trunc(ts / 1.6), locTime], _deviceName);
                this.prevCubie.fromFacelet(newFacelet);
                // if (newFacelet != kernel.getProp('giiSolved', mathlib.SOLVED_FACELET)) {
                //     var rst = kernel.getProp('giiRST');
                //     var confirmed = true; //rst == 'p' ? confirm('Reset bluetooth cube as solved?')
                //     if (rst == 'a' || rst == 'p' && confirmed ) {
                //         console.markSolved();
                //     }
                // }
            } else if (opcode == 0x3) { // state change
                this.sendMessage(msg.slice(2, 7));
                // check timestamps
                var todoMoves = [[msg[34], ts]];
                while (todoMoves.length < 10) {
                    var off = 91 - 5 * todoMoves.length;
                    var hisTs = (msg[off] << 24 | msg[off + 1] << 16 | msg[off + 2] << 8 | msg[off + 3]);
                    var hisMv = msg[off + 4];
                    if (hisTs <= this.lastTs) {
                        break;
                    }
                    todoMoves.push([hisMv, hisTs]);
                }
                if (todoMoves.length > 1) {
                    console.log('[qiyicube] miss history moves', JSON.stringify(todoMoves), this.lastTs);
                }
                var toCallback: GanCubeEvent[] = [];
                var curFacelet;
                for (var i = todoMoves.length - 1; i >= 0; i--) {
                    var axis = [4, 1, 3, 0, 2, 5][(todoMoves[i][0] - 1) >> 1];
                    var power = [0, 2][todoMoves[i][0] & 1];
                    var m = axis * 3 + power;
                    mathlib.CubieCube.CubeMult(this.prevCubie, mathlib.CubieCube.moveCube[m], this.curCubie);
                    this.prevMoves.unshift("URFDLB".charAt(axis) + " 2'".charAt(power));
                    this.prevMoves = this.prevMoves.slice(0, 8);
                    curFacelet = this.curCubie.toFaceCube();
                    toCallback.push({
                        type: "MOVE",
                        cubeTimestamp: Math.trunc(todoMoves[i][1] / 1.6),
                        direction: 1,
                        face: 1,
                        move: this.prevMoves[0].trim(),
                        timestamp: locTime,
                        serial: 1,
                        localTimestamp: locTime
                    }); //[curFacelet, this.prevMoves.slice(), [Math.trunc(todoMoves[i][1] / 1.6), locTime], this.device.name]);
                    var tmp = this.curCubie;
                    this.curCubie = this.prevCubie;
                    this.prevCubie = tmp;
                }
                var newFacelet = this.parseFacelet(msg.slice(7, 34));
                if (newFacelet != curFacelet) {
                    console.log('[qiyicube] facelet', newFacelet);
                    this.curCubie.fromFacelet(newFacelet);
                    
                    //BluetoothCubeHelper.callback(newFacelet, prevMoves, [Math.trunc(ts / 1.6), locTime], this.device.name);
                    var tmp = this.curCubie;
                    this.curCubie = this.prevCubie;
                    this.prevCubie = tmp;
                } else {
                    for (var i = 0; i < toCallback.length; i++) {
                        toCallback.forEach(e => this.events$.next(e));
                    }
                }
                var newBatteryLevel = msg[35];
                if (newBatteryLevel != this.batteryLevel) {
                    this.batteryLevel = newBatteryLevel;
                    //console.updateBattery([batteryLevel, _deviceName]);
                }
            }
            this.lastTs = ts;
        }

    sendMessage(content: string | any[]) : Promise<void> {
        if (!this.stateCharacteristic) {
            return Promise.resolve()// : Promise.reject();
        }
        var msg = [0xfe];
        msg.push(4 + content.length); // length = 1 (op) + cont.length + 2 (crc)
        for (var i = 0; i < content.length; i++) {
            msg.push(content[i]);
        }
        var crc = crc16modbus(msg);
        msg.push(crc & 0xff, crc >> 8);
        var npad = (16 - msg.length % 16) % 16;
        for (var i = 0; i < npad; i++) {
            msg.push(0);
        }
        var encMsg = [];
        
        for (var i = 0; i < msg.length; i += 16) {
            var block = msg.slice(i, i + 16);
            this.decoder.encrypt(block);
            for (var j = 0; j < 16; j++) {
                encMsg[i + j] = block[j];
            }
        }
        return this.stateCharacteristic.writeValue(new Uint8Array(encMsg).buffer);
    }

    onDisconnect = async (): Promise<any> => {
        this.device.removeEventListener('gattserverdisconnected', this.onDisconnect);
        this.stateCharacteristic.removeEventListener('characteristicvaluechanged', this.onStateUpdate);
        this.events$.next({ timestamp: now(), type: "DISCONNECT" });
        this.events$.unsubscribe();
        return this.stateCharacteristic.stopNotifications().catch(() => { });
    }

    async sendCubeCommand(command: GanCubeCommand): Promise<void> {
        // var commandMessage = this.driver.createCommandMessage(command);
        // if (commandMessage) {
        //     return this.sendCommandMessage(commandMessage);
        // }
    }

    async disconnect(): Promise<void> {
        await this.onDisconnect();
        if (this.device.gatt?.connected) {
            this.device.gatt?.disconnect();
        }
    }

}

function crc16modbus(data: string | any[]) {
    var crc = 0xFFFF;
    for (var i = 0; i < data.length; i++) {
        crc ^= data[i];
        for (var j = 0; j < 8; j++) {
            crc = (crc & 0x1) > 0 ? (crc >> 1) ^ 0xa001 : crc >> 1;
        }
    }
    return crc;
}